import React from 'react';
import { useMatch } from 'react-router-dom';

import { useDroneProvider } from '@src/core/features';
import { routesConfig } from '@src/core/routes';
import { MapStatusBanners } from '@src/features/drone/components/map-status-banners';
import { useFlightProvider } from '@src/features/order/provider';
import { useGetOrderMissionQuery } from '@src/features/order/redux';

export const OrderMapStatusBanners: React.FC = () => {
  const takeOffMatch = useMatch(`${routesConfig.takeOffToEnRoute}/:missionId`);
  const enRouteViewerMatch = useMatch(`${routesConfig.enRouteViewer}/:missionId`);
  const readyViewerMatch = useMatch(`${routesConfig.readyForTakeOffViewer}/:missionId`);
  const match = takeOffMatch ?? enRouteViewerMatch ?? readyViewerMatch;
  const missionId = match?.params.missionId;

  const { data } = useGetOrderMissionQuery(missionId, { skip: !missionId });
  const serial = data?.drone?.serialNumber;

  const { drones } = useDroneProvider();
  const { gpsInfo, flightData } = useFlightProvider();

  const liveDrone = React.useMemo(
    () => (serial ? drones.find((drone) => drone.serialNumber === serial) : undefined),
    [drones, serial],
  );

  if (!missionId || !serial) {
    return null;
  }

  const gpsBelongsToActiveDrone = flightData?.serialNumber === serial;
  const gpsLost = Boolean(gpsBelongsToActiveDrone && gpsInfo?.gps_status?.gpsLost);
  const connectionLost = Boolean(liveDrone?.connectionLost);

  return <MapStatusBanners gpsLost={gpsLost} connectionLost={connectionLost} />;
};
